import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toast } from '@heroui/react';
import { ApiError } from './lib/api';
import { App } from './App';
import { isV2Path } from './lib/layout';
import { initializeTheme } from './lib/theme';
import './styles.css';

initializeTheme();
const v2 = isV2Path(window.location.pathname);
const AppV2 = lazy(() => import('./v2/AppV2').then((module) => ({ default: module.AppV2 })));
if (v2) document.documentElement.dataset.dashboardLayout = 'v2';
else delete document.documentElement.dataset.dashboardLayout;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (n, e) => !(e instanceof ApiError && e.status < 500) && n < 2,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {v2 ? (
        <Suspense
          fallback={
            <div className="grid min-h-screen place-items-center text-sm text-ink-3" role="status">
              Preparando tu oficina…
            </div>
          }
        >
          <AppV2 />
        </Suspense>
      ) : (
        <App />
      )}
      <Toast.Provider placement="bottom" />
    </QueryClientProvider>
  </StrictMode>,
);
